<template>
  <div class="pd-skeleton-container">
    <div class="pd-skeleton-container-header">
      <Skeleton height="20px" width="150px" borderRadius="4px" />
      <Skeleton height="18px" width="216px" borderRadius="4px" />
    </div>

    <div class="pd-skeleton-container-main">
      <div class="pd-skeleton-container-main-middle">
        <div class="pd-skeleton-container-main-middle-content">
          <div class="pd-skeleton-container-main-middle-content-nested">
            <Skeleton height="16px" width="216px" borderRadius="4px" />
            <Skeleton height="16px" fullWidth borderRadius="4px" />
            <Skeleton height="16px" width="464px" borderRadius="4px" />
            <Skeleton height="16px" width="867px" borderRadius="4px" />
            <Skeleton height="16px" width="567px" borderRadius="4px" />
            <Skeleton height="16px" width="700px" borderRadius="4px" />
            <Skeleton height="16px" width="953px" borderRadius="4px" />
            <Skeleton height="16px" width="500px" borderRadius="4px" />
            <Skeleton height="16px" fullWidth borderRadius="4px" />
            <Skeleton height="16px" width="953px" borderRadius="4px" />
            <Skeleton height="16px" width="826px" borderRadius="4px" />
          </div>
        </div>
        <div class="pd-skeleton-container-main-middle-bottom">
          <Skeleton height="20px" width="20px" borderRadius="4px" />
          <Skeleton height="36px" width="954px" borderRadius="4px" />
        </div>
      </div>
    </div>

    <div class="pd-skeleton-container-footer">
      <div class="pd-skeleton-container-footer-left">
        <Skeleton width="20px" height="20px" borderRadius="4px" />
        <Skeleton width="206px" height="16px" borderRadius="4px" />
      </div>
      <div class="pd-skeleton-container-footer-right">
        <Skeleton width="212px" height="40px" borderRadius="6px" />
      </div>
    </div>
  </div>
</template>

<script setup>
import Skeleton from '@/components/Skeleton/Skeleton';
</script>

<style lang="scss" scoped>
@import '@/assets/styles/variables.scss';

.pd-skeleton-container {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 16px;
  align-self: stretch;
  padding-bottom: 24px;
  border-radius: 8px;
  border: 1px solid $colorD20;
  background: $colorN00;

  &-header,
  &-main-middle-bottom,
  &-footer,
  &-footer-left,
  &-footer-right {
    display: flex;
    align-items: center;
  }

  &-header,
  &-main,
  &-main-middle,
  &-main-middle-content,
  &-main-middle-bottom,
  &-footer {
    align-self: stretch;
  }

  &-main,
  &-main-middle,
  &-main-middle-content,
  &-main-middle-content-nested {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
  }

  &-header {
    padding: 24px 24px 16px 24px;
    justify-content: space-between;
    border-bottom: 0.5px solid $colorD20;
  }

  &-main {
    padding: 0 24px;
    gap: 24px;

    &-middle {
      gap: 16px;

      &-content {
        padding: 12px;
        flex: 1 0 0;
        border: 1px solid $colorD20;
        border-radius: 8px;

        &-nested {
          width: 962px;
          gap: 8px;
        }
      }

      &-bottom {
        gap: 8px;
      }
    }
  }

  &-footer {
    justify-content: flex-end;
    gap: 16px;
    padding-right: 24px;

    &-left {
      gap: 8px;
    }

    &-right {
      justify-content: center;
      gap: 2px;
    }
  }
}
</style>
